import { useCallback, useEffect, useState } from 'react';
import { useService } from '~/services/service.base';
import { AuthService } from '~/services/service.auth';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '~/routes/routes';
import Cookies from 'js-cookie';
import { EAuthCookies } from '~/shared/types';
import { ServiceIframe } from '~/services/service.iframe';
export const RouteWrapper = ({ component }) => {
    const authService = useService(AuthService);
    const iframeService = useService(ServiceIframe);
    const navigate = useNavigate();
    const autoSignInCookie = Cookies.get(EAuthCookies.autoSignIn);
    const [currentComponent, setCurrentComponent] = useState(null);
    const handleAutoSignIn = useCallback(async (cookieValue) => {
        const autoSignInResponse = await authService.autoSignIn(cookieValue);
        if (autoSignInResponse.data.model?.allow) {
            setCurrentComponent(component);
        }
        else {
            navigate(ROUTES.LOGIN.path);
        }
    }, [authService, component, navigate]);
    useEffect(() => {
        if (!authService.isLogged && autoSignInCookie) {
            handleAutoSignIn(autoSignInCookie).catch(() => navigate(ROUTES.LOGIN.path));
        }
        else if (authService.isLogged && !autoSignInCookie && iframeService.inIframe) {
            authService.setAuthInfo();
            setCurrentComponent(component);
        }
        else {
            setCurrentComponent(component);
        }
    }, [authService, autoSignInCookie, handleAutoSignIn, navigate, component, iframeService]);
    return currentComponent;
};
